import * as React from "react"

import { cn } from "@/lib/utils"

export interface TextAreaProps
  extends Omit<React.ComponentProps<"textarea">, "onChange"> {
  onChange?: (value: string) => void
}

function Textarea({ className, value, onChange, ...props }: TextAreaProps) {
  function handleChange(e: React.ChangeEvent<HTMLTextAreaElement>) {
    if (onChange) {
      onChange(e.target.value)
    }
  }

  return (
    <textarea
      data-slot="textarea"
      className={cn(
        `
                    border-input-border placeholder:text-muted-foreground 
                    focus-visible:border-ring focus-visible:ring-ring/50 
                    aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 
                    aria-invalid:border-destructive dark:bg-input/30 flex 
                    field-sizing-content min-h-30 w-full rounded-sm border 
                    bg-white px-3 py-2 text-base 
                    transition-[color,box-shadow] outline-none focus-visible:ring-[3px] 
                    disabled:cursor-not-allowed disabled:opacity-50 md:text-sm
                `,
        className
      )}
      value={value || ""}
      onChange={handleChange}
      {...props}
    />
  )
}

export { Textarea }
